/* eslint-disable padded-blocks */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable indent */
import { createModule, mutation } from 'vuex-class-component';
import { i18n } from '@/plugins/i18n';
import { Route } from 'vue-router';

import { BreadCrumbModel } from '@/models/breadcrumb';

const VuexModule = createModule({
    namespaced: 'BreadCrumb',
    strict: false,
    target: 'nuxt',
});

export default class BreadCrumbStore extends VuexModule {
    private breadcrumbList: BreadCrumbModel[] = [];
    private visible = true;

    /** Update the breadcrumb list. */
    @mutation
    updateBreadCurmbs(route: Route): void {
        if (route.name) {
            this.visible = !['partners', 'contractDuration', 'contractData', 'previewContract'].includes(route.name);
        }

        if (!this.visible) return;

        const breadcrumbs: BreadCrumbModel[] = [
            {
                external: false,
                text: i18n.t('home').toString(),
                title: i18n.t('title').toString(),
                href: '/applications/landing',
                // exact: false,
                // link: true,
            },
        ];

        route.matched.forEach((val) => {
            if ('breadcrumb' in val.meta) {
                if (route.name === 'contractDetails') {
                    breadcrumbs.push({
                        text: 'العقود',
                        to: { name: 'userContracts' },
                        exact: true,
                        link: true,
                    } as BreadCrumbModel);
                }
                breadcrumbs.push(val.meta.breadcrumb);
            }
        });

        this.breadcrumbList = breadcrumbs.map((breadcrumb, index) => ({
            ...breadcrumb,
            external: breadcrumb.external || false,
            disabled: index === (breadcrumbs.length - 1),
        }));
    }

    /** Get the current breadcrumb list. */
    get breadcrumbs(): BreadCrumbModel[] {
        return this.breadcrumbList;
    }

    /** Controls the visibilty of the breadcrumb component. */
    get isVisible(): boolean {
        return this.visible;
    }
}
